<template>
  <div class="settings-list">
    <div class="menu-pages-list">
      <button class="menu-pages-item">
        <div class="menu-item-name-block">
          <div class="menu-item-image green">
            <bell-icon class="menu-item-svg" />
          </div>
          <div>
            <p class="menu-item-name">
              {{ $t("homePage.settingsNotification") }}
            </p>
            <p class="menu-item-sub-name">
              {{ $t("homePage.settingsNotificationDesk") }}
            </p>
          </div>
        </div>
        <label class="switch">
          <input
            type="checkbox"
            :class="[`input ${isCheckedOnlinePayments ? 'checked' : ''}`]"
            @click="$emit('set-is-use-online-payments')"
          />
          <span class="slider"></span>
        </label>
      </button>
      <button class="menu-pages-item" @click="$emit('set-is-use-nfc-payments')">
        <div class="menu-item-name-block">
          <div class="menu-item-image yellow">
            <dollar-sign-icon class="menu-item-svg" />
          </div>
          <div>
            <p class="menu-item-name">
              {{ $t("homePage.settingsMainCurrency") }}
            </p>
            <p class="menu-item-sub-name">
              {{ $t("homePage.settingsMainCurrencyDesk") }}
            </p>
          </div>
        </div>
        <div class="price-list-block" @click.stop="setIsOpenList()">
          <p class="dropdown-list-checked-value">{{ checkedValue }}</p>
          <chevron-down-icon
            class="dropdown-chevron-icon"
            :style="[
              isOpenList && { transform: 'translateY(-50%) rotate(180deg)' },
            ]"
          />
        </div>
        <!-- <div v-if="isOpenList" class="dropdown-list">
          <vue-perfect-scrollbar class="list-scroll-area">
            <div
              v-for="option of getCurrency"
              :key="option.id"
              class="dropdown-item"
              @click="setIsCheckElement(option)"
            >
              {{ option.code_alfa }}
            </div>
          </vue-perfect-scrollbar>
        </div> -->
      </button>
      <button class="menu-pages-item" @click="$emit('set-is-use-nfc-payments')">
        <div class="menu-item-name-block">
          <div class="menu-item-image purple">
            <globe-icon class="menu-item-svg" />
          </div>
          <p class="menu-item-name">{{ $t("homePage.settingsLang") }}</p>
        </div>
        <div
          class="price-list-block language"
          @click.stop="setIsOpenList('lang')"
        >
          <p class="dropdown-list-checked-value">{{ checkedLangValue }}</p>
          <chevron-down-icon
            class="dropdown-chevron-icon"
            :style="[
              isOpenLangList && {
                transform: 'translateY(-50%) rotate(180deg)',
              },
            ]"
          />
        </div>
        <div v-if="isOpenLangList" class="dropdown-list-language">
          <vue-perfect-scrollbar class="list-scroll-area">
            <div
              v-for="option of languages"
              :key="option.id"
              class="dropdown-item language"
              @click="setChangeLang(option)"
            >
              {{ option.name }}
            </div>
          </vue-perfect-scrollbar>
        </div>
      </button>
      <!-- <button class="menu-pages-item" @click="onOpenPaymentPage">
        <div class="menu-item-name-block">
          <div class="menu-item-image blue">
            <shopping-bag-icon class="menu-item-svg" />
          </div>
          <div>
            <p class="menu-item-name">{{ $t('homePage.settingsPay') }}</p>
            <p class="menu-item-sub-name">{{ $t('homePage.settingsPayDesk') }}</p>
          </div>
        </div>
        <chevron-right-icon class="menu-item-active-page-icon" />
      </button> -->
      <a href="https://t.me/FIN_boto_support_bot" class="menu-pages-item">
        <div class="menu-item-name-block">
          <div class="menu-item-image mint">
            <help-circle-icon class="menu-item-svg" />
          </div>
          <div>
            <p class="menu-item-name">{{ $t("homePage.settingsHelp") }}</p>
            <p class="menu-item-sub-name">
              {{ $t("homePage.settingsHelpDesk") }}
            </p>
          </div>
        </div>
        <chevron-right-icon class="menu-item-active-page-icon" />
      </a>
      <!-- <button class="menu-pages-item" @click="setDeleteAllOperations">
        <div class="menu-item-name-block">
          <div class="menu-item-image red">
            <x-circle-icon class="menu-item-svg" />
          </div>
          <div>
            <p class="menu-item-name">{{ $t('homePage.clearAccountButton') }}</p>
            <p class="menu-item-sub-name">{{ $t('homePage.clearAccountTitle') }}</p>
          </div>
        </div>
        <chevron-right-icon class="menu-item-active-page-icon" />
      </button> -->
    </div>
    <fixed-bottom-list
      :title="$t('homePage.settingsMainCurrency')"
      :isShowFixedCategoryBlock="isOpenList"
      :list="getCurrency"
      type="currency"
      @set-is-open-fixed-list="setIsOpenList"
      @on-check-item-list="setIsCheckElement"
    />
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { onVibrate } from "../../helpers/utils";
import { mapMutations } from "vuex";
import {
  ChevronRightIcon,
  ChevronDownIcon,
  GlobeIcon,
  HelpCircleIcon,
  // ShoppingBagIcon,
  // XCircleIcon,
  BellIcon,
  DollarSignIcon,
} from "vue-feather-icons";
import langObject from "../../libs/i18n/index";
import FixedBottomList from "../FixedBottomList.vue";

export default {
  name: "Settings-list",
  components: {
    ChevronRightIcon,
    ChevronDownIcon,
    DollarSignIcon,
    FixedBottomList,
    // ShoppingBagIcon,
    // XCircleIcon,
    BellIcon,
    GlobeIcon,
    HelpCircleIcon,
    VuePerfectScrollbar,
  },
  props: {
    isOpenMenuSideBar: {
      type: Boolean,
      require: true,
    },
    isCheckedOnlinePayments: {
      type: Boolean,
      require: true,
    },
    isCheckedNFCPayments: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      isOpenList: false,
      isOpenLangList: false,
      checkedValue: null,
      checkedLangValue: null,
      languages: [
        { id: 1, value: "uk", name: "Українська" },
        { id: 2, value: "en", name: "English" },
        { id: 3, value: "es", name: "Español" },
        { id: 4, value: "ru", name: "Русский" },
      ],
      Telegram: window.Telegram.WebApp,
    };
  },
  async mounted() {
    this.checkedValue = this.getMainCurrency.code_alfa;
    this.checkedLangValue = this.getCurrentLang.name;
  },

  methods: {
    ...mapMutations(["setMainCurrency", "saveLanguages"]),
    setIsOpenList(val) {
      if (val === "lang") {
        this.isOpenLangList = !this.isOpenLangList;
      } else {
        this.isOpenList = !this.isOpenList;
      }
    },
    async setChangeLang(lang) {
      onVibrate("click");
      await window.localStorage.setItem("mainLanguages", JSON.stringify(lang));
      this.checkedLangValue = lang.name;
      langObject.locale = lang.value;
      this.saveLanguages(lang);
      this.isOpenLangList = false;
    },
    async setIsCheckElement(val) {
      onVibrate("click");
      await window.localStorage.setItem("mainCurrency", JSON.stringify(val));
      this.setMainCurrency(val);
      this.checkedValue = val.code_alfa;
      this.isOpenList = false;
    },
    onOpenPaymentPage() {
      this.$emit("set-open-payment-page");
    },
    setDeleteAllOperations() {
      this.$emit("set-is-open-delete-all");
    },
  },
  computed: {
    currentCustomer() {
      return this.$store.getters.currentCustomer;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getMainCurrency() {
      return this.$store.getters.getMainCurrency;
    },
    getCurrentLang() {
      return this.$store.getters.getCurrentLang;
    },
  },
  watch: {},
};
</script>

<style scoped>
.menu-header-block {
  display: flex;
  padding: 5px 0 30px 0;
  margin-left: 15px;
  margin-right: 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.header-sub-title {
  margin-bottom: -6px;
  font-size: 13px;
  font-family: "Source Sans 3", sans-serif;
  font-weight: 600;
  color: #4a89dc;
  letter-spacing: -0.2px;
}

.header-main-title {
  font-size: 28px;
  margin-bottom: -3px;
  line-height: 30px;
  font-weight: 700;
  letter-spacing: -0.6px;
  color: #1b1b1b;
  font-family: "Source Sans 3", sans-serif;
}

.menu-header-image {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  width: 45px;
  height: 45px;
  transition: all 120ms ease;
  border-radius: 20px !important;
  border: none;
  background-image: var(--main-bg-color);
  position: relative;
  z-index: 10;
  overflow: visible !important;
  cursor: pointer;
}

.menu-header-image::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.85) translateY(5px) translateZ(10px);
  filter: blur(8px);
}

.menu-header-image-card {
  width: 45px;
  height: 45px;
  margin-left: auto;
  border-radius: 20px;
}

.menu-header-image-icon {
  color: #fff;
  margin: auto;
}

.menu-pages-list {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  margin-left: 15px;
  margin-right: 15px;
}

.menu-pages-item {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.menu-pages-item:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.menu-item-name-block {
  display: flex;
  gap: 20px;
}

.menu-item-image {
  display: flex;
  position: relative;
  text-align: center;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 12px;
}

.menu-item-image.green {
  background-image: linear-gradient(to bottom, #a0d468, #8cc152);
}

.menu-item-image.purple {
  background-image: linear-gradient(to bottom, #ac92ec, #967adc);
}

.menu-item-image.blue {
  background-image: linear-gradient(to bottom, #5d9cec, #4a89dc);
}

.menu-item-image.red {
  background-image: linear-gradient(to bottom, #ed5565, #d84558);
}

.menu-item-image.yellow {
  background-image: linear-gradient(to bottom, #ffce54, #f6bb42);
}

.menu-item-image.mint {
  background-image: linear-gradient(to bottom, #48cfad, #37bc9b);
}

.menu-item-image:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.85) translateY(5px) translateZ(10px);
  filter: blur(8px);
}

.menu-item-svg {
  color: #fff;
  width: 18px;
  height: 18px;
  margin: auto;
}

.menu-item-name {
  font-family: "Source Sans 3", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  letter-spacing: -0.6px;
  line-height: 15px;
  cursor: pointer;
  height: 15px;
  margin: auto 0;
  text-align: left;
}

.menu-item-sub-name {
  font-family: "Source Sans 3", sans-serif;
  color: #000;
  letter-spacing: -0.6px;
  line-height: 15px;
  font-size: 11px;
  font-weight: 400;
  opacity: 0.4;
  text-align: left;
}

.menu-item-active-page-icon {
  color: #00000080;
  width: 10px;
  height: 10px;
  margin: auto 0;
}
/* ///////////////////////////// */

.switch {
  font-size: 17px;
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  margin: auto 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #eaeaea;
  transition: 0.4s;
  border-radius: 30px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  border-radius: 20px;
  left: 0px;
  bottom: 1px;
  z-index: 2;
  background-color: #fff;
  transition: 0.4s;
}

.price-list-block {
  padding: 5px 15px 5px 0px;
  font-size: 0.75rem;
  border: 1px rgba(0, 0, 0, 0.07) solid;
  border-radius: 10px;
  background: #e8e8e8;
  width: 65px;
  height: 30px;
  cursor: pointer;
}

.price-list-block.language {
  width: auto;
  padding: 5px 30px 5px 8px;
}

.dropdown-list-checked-value {
  font-weight: 400;
  line-height: 20px;
  font-size: 14px;
  font-family: "Source Sans 3", sans-serif;
  color: #212529;
}

.dropdown-chevron-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 17px;
  height: 17px;
  margin-left: auto;
  transition: all 0.25s ease;
}
.dropdown-list {
  position: absolute;
  width: 80px;
  z-index: 100;
  top: 45px;
  right: 0px;
  height: 110px;
  background: #e8e8e8;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 10px;
  overflow: hidden;
}

.dropdown-list-language {
  position: absolute;
  width: 105px;
  z-index: 100;
  bottom: 45px;
  right: 0px;
  height: 110px;
  background: #e8e8e8;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 10px;
  overflow: hidden;
}

.list-scroll-area {
  max-height: 100px;
  width: 100%;
}
.dropdown-item {
  font-weight: 400;
  line-height: 1.5;
  font-size: 15px;
  background: transparent;
  font-family: "Source Sans 3", sans-serif;
  color: #212529;
  padding: 5px 10px;
  max-width: 50px;
  overflow: hidden;
  transition: all 0.25s ease;
}
.dropdown-item:hover {
  background-image: var(--main-bg-color);
  color: #fff;
  border-radius: 3px;
  padding-left: 14px;
}

.dropdown-item.language {
  text-align: left;
  max-width: 150px;
  padding: 5px;
}
.input.checked + .slider {
  background-color: #8cc152;
}

.input:focus + .slider {
  box-shadow: 0 0 1px #183153;
}

.input.checked + .slider:before {
  transform: translateX(22px);
}
</style>
